import { FC } from 'react';
import { Button, Dialog } from '@chakra-ui/react';

interface TwoOptionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  bodyText: string;
  cancelButtonText: string;
  acceptButtonText: string;
  onAccept: () => void;
}

// TODO: @haxxxton this is very similar to the ConfirmAction and Unsaved components
const TwoOptionDialog: FC<TwoOptionDialogProps> = ({
  isOpen,
  onClose,
  headerText,
  bodyText,
  cancelButtonText,
  acceptButtonText,
  onAccept,
}) => (
  <Dialog.Root onOpenChange={onClose} open={isOpen} role="alertdialog">
    <Dialog.Backdrop />
    <Dialog.Positioner>
      <Dialog.Content>
        <Dialog.Header color="navy.500" fontSize="lg" fontWeight="bold">
          {headerText}
        </Dialog.Header>

        <Dialog.Body pl={6}>{bodyText}</Dialog.Body>

        <Dialog.Footer>
          <Dialog.ActionTrigger asChild>
            <Button colorPalette="gray" onClick={onClose} variant="outline">
              {cancelButtonText}
            </Button>
          </Dialog.ActionTrigger>
          <Button
            colorPalette="primary"
            ml={3}
            onClick={onAccept}
            variant="solid"
          >
            {acceptButtonText}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
);

export default TwoOptionDialog;
